import React from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        overflowX: 'auto',
        padding: theme.spacing(1),
        '&::-webkit-scrollbar': {
            height: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.grey[400],
            borderRadius: '4px',
        },
    },
    noticeItem: {
        position: 'relative',
        marginRight: theme.spacing(2),
        flex: '0 0 auto',
        width: '500px', // 5:1 비율을 위한 가로 크기
        height: '100px', // 5:1 비율을 위한 세로 크기
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        boxShadow: theme.shadows[1],
        backgroundColor: theme.palette.background.paper,
        '&:last-child': {
            marginRight: 0,
        },
    },
    noticeImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover', // 이미지가 컨테이너를 채우도록 설정
    },
    deleteButton: {
        position: 'absolute',
        top: theme.spacing(0.5),
        right: theme.spacing(0.5),
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
        },
    },
    noNotices: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.grey[200],
        borderRadius: theme.shape.borderRadius,
        textAlign: 'center',
    },
}));

function NoticeViewer({ notices, onDelete }) {
    const classes = useStyles();
    const intl = useIntl();

    if (!notices || notices.length === 0) {
        return (
            <Typography className={classes.noNotices}>
                {intl.formatMessage({ id: "noticeViewer.noNotices" })}
            </Typography>
        );
    }

    console.log('NoticeViewer notices:', notices);

    return (
        <Box className={classes.root}>
            {notices.map((notice) => (
                <Box key={notice.id} className={classes.noticeItem}>
                    <img src={notice.notice} alt="Notice" className={classes.noticeImage} />
                    <IconButton
                        className={classes.deleteButton}
                        onClick={() => onDelete(notice.id)}
                        aria-label={intl.formatMessage({ id: "noticeViewer.delete" })}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Box>
            ))}
        </Box>
    );
}

export default NoticeViewer;